import { Course } from "./course.model";
import { Exercise } from "./exercise.model";
import { Group } from "./group.model";
import { Homework } from "./homework.model";
import { ModuleTest } from "./module-test.model";
import { Theory } from "./theory.model";

export type ModuleStatus = ('active'|'inactive');

export class Module {
    id?: number;
    number?: string;
    title?: string;
    description?: string;
    status?: ModuleStatus;
    course?: Course;
    group?: Group;
    homework?: Homework;
    exercises?: Exercise[];
    theory_elements?: Theory[];
    theory_teacher?: string;
    module?: Module;
    test?: ModuleTest;

    static fromJson(fields: any): Module {
        let item = Object.assign(new this(), fields);
        item.course = Course.fromJson(fields?.course);
        item.group = Group.fromJson(fields?.group);
        item.homework = Homework.fromJson(fields?.homework);
        item.exercises = fields?.exercises?.map((item: any) => Exercise.fromJson(item));
        item.theory_elements = fields?.theory_elements?.map((item: any) => Theory.fromJson(item));

        return item;
    }

    toggleStatus(): ModuleStatus {
        return this.status === 'active' ? 'inactive' : 'active';
    }
}
